module.exports = global["Promise"] = require("-!./es6-promise.js");